// import external dependencies
import "jquery";

// Import everything from autoload
//import "./autoload/_bootstrap.js";

// import local dependencies
// import Router from './util/Router';
// import common from './routes/common';
// import home from './routes/home';
// import aboutUs from './routes/about';
import StateManager from "./scuba/StateManager";
import LayoutManager from "./scuba/LayoutManager";
import HorizontalLayout from "./scuba/HorizontalLayout";
import MobileLayout from "./scuba/MobileLayout";

require("./scuba/Navigation");
require("./scuba/Content");
require("./scuba/ListForm");
require("./scuba/ListSnap");
require("./scuba/ListLazyLoading");
require("./scuba/Menu");
require("./scuba/MobileLayout");

require("./components/Carousel");
require("./components/ExpandingGrid");
require("./components/Pipeline");


const _ = require("underscore");
/** Populate Router instance with DOM routes */
// const routes = new Router({
//   // All pages
//   common,
//   // Home page
//   home,
//   // About Us page, note the change from about-us to aboutUs.
//   aboutUs,
// });
LayoutManager.setLayouts([new HorizontalLayout(), new MobileLayout()]);

// initialisation
$(document).ready(function() {
  var $body = $(document.body);
  var $wrap = $(".js-scuba__wrap").first();
  var $head = $(".js-scuba__head").first();
  var $main = $(".js-scuba__main").first();

  if ("ontouchstart" in document.documentElement) {
    console.log("touch-screen !!!");
    $(document.body).addClass("touch-screen");
  } else {
    $(document.body).removeClass("touch-screen");
  }

  if ($(".prev-button")[0]) {
    var $link = $(".prev-button").find("a");
    // console.log($link);
    if ($link[0]) {
      const href = $link.attr("href");
      const DOM = '<link rel="prev" href="' + href + '">';
      $("head").append(DOM);
    }
  }
  if ($(".next-button")[0]) {
    var $link = $(".next-button").find("a");
    if ($link[0]) {
      const href = $link.attr("href");
      const DOM = '<link rel="next" href="' + href + '">';
      $("head").append(DOM);
    }
  }
  $("ul li:has(a)").addClass("blue_dot");
  document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    console.log(anchor);
    anchor.addEventListener("click", function(e) {
      e.preventDefault();
      const searchName =
        "a[name$='" + this.getAttribute("href").split("#")[1] + "']";
      const scrollNumber = $(searchName)[0].offsetTop - 140;
      window.scrollTo({
        top: scrollNumber,
        behavior: "smooth"
      });
    });
  });

  if (!$wrap.length) {
    $wrap = $('<div class="js-scuba__wrap"></div>').prependTo($body);
    $head.appendTo($wrap);
    $main.appendTo($wrap);
  }

  $(document).on("click", "a", function(event) {
    // récupération du lien
    var $link = $(event.currentTarget);

    // récupération des informations
    var href = $link.attr("href");
    var target = $link.attr("target");
    var dataTarget = $link.attr("data-target");
    // var dataHeight = $link.attr('data-height') ||  ( parseInt( $(window).height() * 0.9 ) ) ;
    // var dataWidth = $link.attr('data-width') || Math.min ( parseInt( ( $(window).width() * 0.9 ) ) , 768 ) ;
    var callback = $link.attr("data-callback") || null;
    if (
      $(event.currentTarget)[0].href.includes("mailto") ||
      $(event.currentTarget)[0].href.includes("logout")
    ) {
      false;
    } else if (
      (location.hostname !== $(event.currentTarget)[0].hostname &&
        !$(event.currentTarget).hasClass("no-target-blank") &&
        href.indexOf("http") !== -1) ||
      $(event.currentTarget)[0].pathname.indexOf(".") !== -1
    ) {
      window.open(href, "_blank");
      event.preventDefault();
    }
    if (target !== "_blank") {
      // lien à gérer par un JS
      if (href === "#") {
        if (callback && callback != "") eval(callback);
        event.preventDefault();
      }
      // liens de DGT NAV
      else if (dataTarget && dataTarget === "reload") {
        false;
      } else if (
        (dataTarget && dataTarget !== "cover") ||
        $link.closest(".js-scuba__nav").length
      ) {
        event.preventDefault();

        // récupère le page url pour retrouver le contexte en self ou after
        var pageUrl = $link
          .closest(".js-scuba__head,.js-scuba__page")
          .data("url");

        // montre qu'on charge le lien
        $link.addClass("is-loading");
        if ($(event.currentTarget).hasClass("no-target-blank")) {
          window.open(href, "_self");
        } else {
          // console.log("change page ?");
          StateManager.pushState(href, dataTarget, pageUrl).fin(function() {
            // remet dans l'état normal
            $link.removeClass("is-loading");
          });
        }
      }
    }
  });

  $(document).on("click", ".js-scuba__back", function(event) {
    StateManager.popState();
    event.preventDefault();
  });

  $(window).on(StateManager.STATE_CHANGE, function(event, state) {
    console.log("StateManager.state_change()");
    var lastPage = _.last(state);
    if (lastPage) {
      var $page = lastPage.$element;
      var url = $page.data("url");
      ////a fix
      // ga('send', 'pageview', url)
      // condition for google tracking
      var isStats = typeof window._gaq != "undefined" && url != null;
      if (isStats) {
        window._gaq.push(["_trackPageview"], url);
      }
    }
  });

  $(window).on(StateManager.STATE_CHANGE, function() {
    console.log("StateManager.state_change()");
    const layout = LayoutManager.getAvailableLayout();
    const isMobile = layout && layout.name === "MobileLayout";
    if (isMobile) {
      return;
    }
    if ($main.find(".js-scuba__page[data-show-one-menu-section]").length) {
      $body.addClass("scuba-show-one-menu-section");
    } else {
      if ($body.hasClass("scuba-show-one-menu-section")) {
        $body.removeClass("scuba-show-one-menu-section");
        layout.scroll.to(layout.scroll.maxScrollLeft(), 0);
      }
    }
  });

  StateManager.init()
    .then(function() {
      console.log("StateManager.init()");
      LayoutManager.start().then(function() {
        $(document.body).removeClass("is-loading");
      });
    })
    .then(function() {
      const layout = LayoutManager.getAvailableLayout();

      const isDesktop = layout && layout.name === "HorizontalLayout";
      if (isDesktop && !$body.hasClass("scuba-show-one-menu-section")) {
        setTimeout(function() {
          layout.scroll.to(layout.scroll.maxScrollLeft(), 0);
        }, 100);
        //layout.scroll.to(layout.scroll.maxScrollLeft(), 0)
      }
    })
    .fail(function(reason) {
      console.error(reason && reason.stack ? reason.stack : reason);
    });
});



// Load Events
// jQuery(document).ready(() => routes.loadEvents());





// WEBPACK FOOTER //
// ./scripts/main.js